<template>
  <form-base hide-required-legend :teleport-target="dialogTeleportTarget">
    <template #form>
      <v-stepper :items="steps" v-model="step" hide-actions class="warehouse-stepper mx-6" flat>
        <v-stepper-window>
          <v-stepper-window-item v-if="!hideTerms" :value="1">
            <create-warehouse-terms
              v-model="isTermsAccepted"
              @confirm="onTermsNext"
              @cancel="onCancel"
              ref="createWarehouseTerms"></create-warehouse-terms>
          </v-stepper-window-item>

          <v-stepper-window-item :value="this.getStepValue(2)">
            <create-warehouse-form
              @update:valid="setStepTwoValid"
              @confirm="onWarehouseInfoNext"
              @cancel="onFormPrevious"
              ref="createWarehouseForm"></create-warehouse-form>
          </v-stepper-window-item>

          <v-stepper-window-item :value="this.getStepValue(3)">
            <create-warehouse-instructions-form
              @confirm="onFormSubmit"
              @cancel="onFormPrevious"
              ref="createWarehouseInstructionsForm"></create-warehouse-instructions-form>
          </v-stepper-window-item>
        </v-stepper-window>
      </v-stepper>
    </template>
    <template #form-actions>
      <action-group
        :disable-confirm="!hideTerms && step === 1 ? !isTermsAccepted : !isStepTwoSet"
        :confirm-label="
          step === (hideTerms ? 2 : 3)
            ? $t('warehouse.dialogs.createWarehouseDialog.buttons.createWarehouse')
            : $t('global.buttons.next')
        "
        :confirm-icon="null"
        :cancel-icon="null"
        @confirm="!hideTerms && step === 1 ? onTermsNext() : onNext()"
        @cancel="$emit('cancel')">
        <template #additional-actions>
          <v-btn variant="outlined" class="ml-2" v-if="step !== 1" @click="step--">
            {{ $t('global.buttons.previous') }}
          </v-btn>
        </template>
      </action-group>
    </template>
  </form-base>
</template>

<script>
import { inject } from 'vue';

/**
 * Create Warehouse Stepper
 * @displayName Create Warehouse Stepper
 */
export default {
  name: 'CreateWarehouseStepper',
  props: {
    hideTerms: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const defaultSteps = [
      this.$t('warehouse.forms.createWarehouseForm.headers.warehouseInformation'),
      this.$t('warehouse.forms.createWarehouseForm.headers.instructionsAndAmenities')
    ];
    const steps = this.hideTerms
      ? defaultSteps
      : [this.$t('warehouse.forms.createWarehouseForm.headers.conditions'), ...defaultSteps];

    return {
      steps,
      step: 1,
      fields: {},
      isTermsAccepted: false,
      isStepTwoSet: false
    };
  },
  methods: {
    setStepTwoValid(isValid) {
      this.isStepTwoSet = isValid;
    },
    getStepValue(value) {
      return this.hideTerms ? value - 1 : value;
    },
    onTermsNext() {
      this.step++;
    },
    onWarehouseInfoNext(fields) {
      this.fields = { ...this.fields, ...fields };
      this.step++;
    },
    onFormPrevious() {
      this.step--;
    },
    onFormSubmit(fields) {
      this.fields = { ...this.fields, ...fields };
      this.$emit('confirm', this.fields);
    },
    onNext() {
      if (!this.hideTerms && this.step === 1) {
        this.$refs.createWarehouseTerms.onConfirm();
      } else if ((this.hideTerms && this.step === 1) || (!this.hideTerms && this.step === 2)) {
        this.$refs.createWarehouseForm.onConfirm();
      } else {
        this.$refs.createWarehouseInstructionsForm.onConfirm();
      }
    },
    onCancel() {
      this.$emit('cancel');
    }
  },
  mounted() {
    this.mixpanel.track(this.mixpanel.events.ACTION.OPENED_CREATE_WAREHOUSE, {
      'Org Name': this.$org.name,
      'Org ID': this.$org.id
    });
  },
  setup() {
    const dialogTeleportTarget = inject('dialogActionsRef');
    return { dialogTeleportTarget };
  }
};
</script>

<style lang="scss">
.warehouse-stepper {
  //Hide the number inside the stepper
  .v-stepper-item__avatar {
    font-size: 0 !important;
  }

  .v-stepper-item--selected {
    .v-stepper-item__avatar {
      background-color: $color-primary-60 !important;
    }
  }
}
</style>
